<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="addressForm" (ngSubmit)="onSubmit()">
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.ADDRESS_NAME" | translate }}</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              [placeholder]="'ONSIP_I18N.ADDRESS_NAME' | translate"
              [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_EDIT_NAME_INPUT"
              autocomplete="off"
              formControlName="name"
            />
            <mat-error>
              {{ getNameError() }}
            </mat-error>
          </mat-form-field>
        </section>

        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTERNAL_ADDRESS" | translate }}</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              [placeholder]="'ONSIP_I18N.EXTERNAL_ADDRESS' | translate"
              [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_EDIT_ADDRESS_INPUT"
              autocomplete="off"
              formControlName="foreignAddress"
            />
            <mat-error>
              {{ getForeignAddressError() }}
            </mat-error>
          </mat-form-field>
        </section>
      </div>

      <div class="second-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">SIP address</div>
          <onsip-sip-address-field
            formControlName="sipAddress"
            class="sip-address"
          ></onsip-sip-address-field>
        </section>

        <section class="m-b-28">
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <onsip-extensions-list
            #extensionsList
            [currentId]="externalSip.addressId"
            formControlName="extensions"
          >
          </onsip-extensions-list>
        </section>
      </div>
    </div>

    <div class="page-view-controls">
      <button mat-button type="button" class="cancel" (click)="onCancel()" color="primary">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button
        [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_EDIT_SUBMIT_BTN"
        mat-flat-button
        type="submit"
        class="save-btn"
        color="primary"
      >
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
